import { RootState } from '@store/rootReducer'
import { selectUserIsPremium, selectUserRemainingCredits } from '@/store/slices/user/selectors'

export type AIAccessReason = 'premium' | 'credits' | 'noAccess' | 'premiumOutOfCredits'

export interface AIModelsAccessDecision {
  allowed: boolean
  reason: AIAccessReason
  isPremium: boolean
  remainingCredits: number
}

/**
 * Shared access decision for AI Models.
 * Backend remains authoritative for decrementing credits; this is a local eligibility check only.
 */
export function resolveAIModelsAccessDecision(state: RootState): AIModelsAccessDecision {
  const isPremium = selectUserIsPremium(state)
  const remainingCredits = selectUserRemainingCredits(state)

  if (isPremium) {
    if (remainingCredits <= 0) {
      return { allowed: false, reason: 'premiumOutOfCredits', isPremium, remainingCredits }
    }
    return { allowed: true, reason: 'premium', isPremium, remainingCredits }
  }

  if (remainingCredits > 0) {
    return { allowed: true, reason: 'credits', isPremium, remainingCredits }
  }

  return { allowed: false, reason: 'noAccess', isPremium, remainingCredits }
}
